module.exports = __webpack_public_path__ + "img/1-4.049d44a0.png";